<template lang="pug" src="./settings.pug"> </template>
<style lang="scss" src="./settings.scss" scoped> </style>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    data: () => ({
        activeType: null,
        editSetting: false,
        filters: {
            brandId: null
        },
        editedItem: null,
        requestProcessing: false
    }),
    computed: {
        ...mapState({
            configTypes: state => state.settings.configTypes,
            items: state => state.settings.items,
            brands: state => state.data.brands
        }),
        ...mapGetters(['userBrandId']),
        settingRole() {
            return this.$route.meta.settingRole;
        },
        types() {
            return this.configTypes[this.settingRole];
        },
        showSettings() {
            return !(['boss'].includes(this.settingRole) && !this.userBrandId && !this.filters.brandId);
        },
        allowToSelectBrand() {
            return ['boss'].includes(this.settingRole) && !this.userBrandId;
        },
        headers() {
            return ['key', 'value', 'type', 'comment', 'action'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Settings.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    watch: {
        settingRole() {
            this.activeType = null;
        }
    },
    created() {
        this.$store.dispatch('settings/getConfigTypes');
        this.$store.dispatch('data/getBrands');
    },
    methods: {
        getSettings() {
            const configType = this.types[this.activeType];

            if (configType && this.showSettings) {
                this.$store.dispatch('settings/getSettings', {
                    role: this.settingRole,
                    params: {
                        configType,
                        brandId: this.userBrandId || this.filters.brandId
                    }
                });
            }
        },
        edit(item) {
            this.editSetting = true;
            this.editedItem = Object.assign({}, item, {
                value: item.type == 'boolean' ? item.value == 'true' : item.value
            });
        },
        async save() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            const data = Object.assign({}, this.editedItem, {
                value: this.editedItem.type == 'boolean' ? this.editedItem.value.toString() : this.editedItem.value
            });
            const result = await this.$store.dispatch('settings/edit', data);

            if (result) {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                    this.editSetting = false;
                    this.editedItem = null;
                });

                this.getSettings();
            }
        },
        getBooleanValue(value) {
            return value == 'true';
        },
        cancel() {
            this.editSetting = false;
            this.editedItem = null;
        },
        async useDefault() {
            await this.$store.dispatch('settings/useDefaultSettingsForBrand', {
                brandId: this.filters.brandId,
                configType: this.types[this.activeType]
            });

            await this.getSettings();
        },
        async changeDefault() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await this.$store.dispatch('settings/changeDefault', {
                brandId: this.filters.brandId,
                configType: this.types[this.activeType]
            }).finally(() => {
                setTimeout(() => {
                    this.requestProcessing = false;
                }, 500);
            });

            await this.getSettings();
        }
    }
};
</script>
